
import React from 'react';
import Layout from '@/components/layout/Layout';
import SellPortalHero from '@/components/sell-portal/SellPortalHero';
import PartnershipSteps from '@/components/sell-portal/PartnershipSteps';
import BenefitsSection from '@/components/sell-portal/BenefitsSection';
import SellerFAQs from '@/components/sell-portal/SellerFAQs';
import JoinCTA from '@/components/sell-portal/JoinCTA';

const SellPortal: React.FC = () => {
  return (
    <Layout>
      <div className="pt-24 pb-12">
        <SellPortalHero />
        <PartnershipSteps />
        <BenefitsSection />
        <SellerFAQs />
        <JoinCTA />
      </div>
    </Layout>
  );
};

export default SellPortal;
